import { useEffect, useRef, useState } from 'react';
import { $libAlbumId } from '../stores/libState';
import onAlbumClick from '../actions/onAlbumClick';

type Item<T = string> = {
  albumId?: number;
  nav?: T;
};

const store: Map<string, Item> = new Map();

export function useLibRecent<T extends string>(
  id: string,
  defaultNav: T,
  outRangeCheck?: (lastNav?: T) => boolean
) {
  let { nav, albumId } = (store.get(id) ?? {}) as Item<T>;
  if (outRangeCheck?.(nav)) {
    nav = defaultNav;
    albumId = 0;
  }
  const state = useState(nav ?? defaultNav);
  const lastNav = useRef(state[0]);
  useEffect(() => {
    lastNav.current = state[0];
  }, [state[0]]);
  useEffect(() => {
    if (albumId !== undefined) {
      onAlbumClick(albumId);
    }
    return () => {
      store.set(id, { albumId: $libAlbumId.getState(), nav: lastNav.current });
    };
  }, []);
  return state;
}
